import axios from "axios";

export const ANALYTICS_USAGE_LOAD_TEST_API_PATH = "/api/event/plataformaEventos/analytics-dashboard/test";

const identityParams = ({ eventId }) => ({ event_id: Number(eventId) });

export function getAnalyticsUsageLoadTestStatus({ jobId, eventId }) {
    return axios.get(
        `${ANALYTICS_USAGE_LOAD_TEST_API_PATH}/${encodeURIComponent(jobId)}`,
        { params: identityParams({ eventId }) },
    );
}

export function cancelAnalyticsUsageLoadTest({ jobId, eventId }) {
    return axios.post(
        `${ANALYTICS_USAGE_LOAD_TEST_API_PATH}/${encodeURIComponent(jobId)}/cancel`,
        identityParams({ eventId }),
    );
}

export function getAnalyticsUsageLoadTestReport({ jobId, eventId }) {
    return axios.get(
        `${ANALYTICS_USAGE_LOAD_TEST_API_PATH}/${encodeURIComponent(jobId)}/report`,
        { params: identityParams({ eventId }) },
    );
}

export function startAnalyticsUsageLoadTest({ eventId, connectionCount, coveragePreset = "balanced", pacingMode = "realistic" }) {
    return axios.post(ANALYTICS_USAGE_LOAD_TEST_API_PATH, {
        event_id: Number(eventId),
        connection_count: Number(connectionCount),
        analytics_coverage_preset: coveragePreset,
        pacing_mode: pacingMode,
    });
}
